import axios from "axios";
import { get } from "lodash";
import { IOption } from "../models/option.model";
import { FULFILLED, PENDING, REJECTED } from "./action-type.util";

const remapItem = item => ({ id: item["documentID"], ...item });
const remapItems = items => items.map(remapItem);

export const ACTION_TYPES = {
  FETCH_OPTIONS: "brokerTasks/FETCH_OPTIONS",
  FETCH_LIST: "brokerTasks/FETCH_LIST",
  FETCH_DETAIL: "brokerTasks/FETCH_DETAIL",
  SAVE_TASK: "brokerTasks/SAVE_TASK",
  TOGGLE_SAVE_TOAST: "brokerTasks/TOGGLE_SAVE_TOAST",
  DELETE_TASK: "brokerTasks/DELETE_TASK",
  NEW_TASK: "brokerTasks/NEW_TASK",
};

export interface BrokerTask {
  id: number;
  brokerID: number;
  carrierId?: string;
  requirementOriginCode?: string;
  effectiveDate?: string;
  expirationDate?: string;
  orderedDate?: string;
  receivedDate?: string;
  followUpDate?: string;
  description?: string;
  notes?: string;
  priority: boolean;
}

export interface BrokerTaskDetail {
  id: number;
  brokerID: number;
  carrierId: number;
  priority: boolean;
  requirementOriginCode: string;
  taskStatusCode: string;
  effectiveDate: string;
  expirationDate: string;
  orderedDate: string;
  followUpDate: string;
  receivedDate: string;
  notes: string;
  taskCodeTypeID: string;
  description: string;
  selectCarrierTypeList: IOption[];
  selectStatusTypeList: IOption[];
  selectRequiredOriginList: IOption[];
  selectTaskCodeTypeList: IOption[];
}

const initialState = {
  task: {} as BrokerTaskDetail,
  options: {} as BrokerTaskDetail,
  inProcess: false,
  uploadModal: {
    documentTypes: new Array<IOption>(),
  },
  isUploadToastVisible: false,
};

export type BrokerTasksState = Readonly<typeof initialState>;

/**
 * Correspondence Reducer
 */
export default (state: BrokerTasksState = initialState, action): BrokerTasksState => {
  switch (action.type) {
    // Pending
    case PENDING(ACTION_TYPES.SAVE_TASK):
    case PENDING(ACTION_TYPES.FETCH_DETAIL): {
      return {
        ...state,
      };
    }

    // Fulfilled
    case FULFILLED(ACTION_TYPES.FETCH_DETAIL): {
      return {
        ...state,
        task: action.payload.data,
      };
    }

    case FULFILLED(ACTION_TYPES.FETCH_OPTIONS): {
      return {
        ...state,
        options: action.payload.data,
        task: action.payload.data,
      };
    }

    // Rejected
    case REJECTED(ACTION_TYPES.FETCH_DETAIL): {
      return {
        ...state,
      };
    }

    case FULFILLED(ACTION_TYPES.SAVE_TASK): {
      return {
        ...state,
        inProcess: false,
        isUploadToastVisible: true,
      };
    }

    case ACTION_TYPES.TOGGLE_SAVE_TOAST: {
      const isUploadToastVisible = get(action, "meta.open");
      return {
        ...state,
        isUploadToastVisible,
      };
    }

    case ACTION_TYPES.NEW_TASK: {
      return {
        ...state,
        task: {} as BrokerTaskDetail,
      };
    }

    default: {
      return {
        ...state,
      };
    }
  }
};

export const fetchBrokerTaskOptions = () => {
  return {
    type: ACTION_TYPES.FETCH_OPTIONS,
    payload: axios.get(`brokers/tasks/new`).then(response => {
      return response;
    }),
  };
};

export const fetchBrokerTask = (id: number) => {
  return {
    type: ACTION_TYPES.FETCH_DETAIL,
    payload: axios.get(`brokers/tasks/${id}`).then(response => {
      return response;
    }),
  };
};

export const fetchBrokerTasks = (brokerID: string) => {
  return {
    type: ACTION_TYPES.FETCH_LIST,
    payload: axios.get(`brokers/${brokerID}/tasks`),
  };
};

export const saveBrokerTask = (brokerID: string, data: BrokerTask) => {
  return {
    type: ACTION_TYPES.SAVE_TASK,
    payload: axios.post(`brokers/${brokerID}/taskDetails`, {
      brokerID,
      ...data,
    }),
  };
};

export const deleteBrokerTasks = (brokerID: string, taskID: string) => {
  return {
    type: ACTION_TYPES.DELETE_TASK,
    payload: axios.delete(`brokers/${brokerID}/tasks/${taskID}`),
  };
};

export const toggleBrokerUploadToast = (open: boolean) => {
  return {
    type: ACTION_TYPES.TOGGLE_SAVE_TOAST,
    meta: { open },
  };
};

export const newTask = () => {
  return {
    type: ACTION_TYPES.NEW_TASK,
  };
};
